import type { TypePolicies } from '@apollo/client'
import possibleTypesResult from '@gql-generated/possibleTypes.json'

/**
 * Union and interface memberships shared by the browser Apollo client and the tests
 * (MockedProvider), so a fragment spread on a union resolves in tests exactly as it
 * does in the app.
 */
export const APOLLO_POSSIBLE_TYPES = possibleTypesResult.possibleTypes

/**
 * Cache normalization rules shared by the browser Apollo client and the tests
 * (MockedProvider), so the test cache merges entities exactly like the app does.
 */
export const APOLLO_TYPE_POLICIES: TypePolicies = {
  Brand: { keyFields: ['urlKey'] },
  CartItem: {
    keyFields: false,
    fields: {
      discount: {
        merge(existing = {}, incoming = {}) {
          return { ...existing, ...incoming }
        },
      },
    },
  },
  Cart: {
    fields: {
      items: {
        merge(_, incoming = []) {
          return incoming
        },
      },
      itemsGroupedByEarliestDeliveryDate: {
        keyArgs: false,
        merge(_, incoming = []) {
          return incoming
        },
      },
      itemsSplitByDeliveryDate: { keyArgs: false },
    },
  },
  Checkout: {
    keyFields: [],
    fields: {
      cart: { keyArgs: false },
    },
  },
  CollaboratorPermissions: { keyFields: [] },
  CompanyNationalIdConfig: { keyFields: [], merge: true },
  CompanyNationalIdFormat: { keyFields: [], merge: true },
  Config: { keyFields: [], merge: true },
  ConfigCaptcha: { keyFields: [], merge: true },
  ConfigCatalog: { keyFields: [], merge: true },
  ConfigCustomer: { keyFields: [], merge: true },
  ConfigSales: { keyFields: [], merge: true },
  ConfigSite: { keyFields: [], merge: true },
  ConfigSupport: { keyFields: [], merge: true },
  Country: { keyFields: ['iso'] },
  Delivery: { keyFields: [] },
  OrderBuyer: { keyFields: false },
  Payment: { merge: true },
  PaymentMethod: { merge: true },
  PaymentMethodCard: { merge: true },
  PaymentMethodIdeal: { merge: true },
  PaymentMethodTerm: { merge: true },
  PointOfSale: { keyFields: false },
  ProductAnalytics: { keyFields: [] },
  Product: {
    keyFields: ['reference'],
    fields: {
      price: {
        merge(existing = {}, incoming = {}) {
          return { ...existing, ...incoming }
        },
      },
    },
  },
  Shipping: {
    keyFields: [],
    fields: {
      fee: {
        merge(_, incoming = []) {
          return incoming
        },
      },
    },
  },
  User: {
    fields: {
      checkout: { keyArgs: [] },
      quickOrderList: { keyArgs: ['firstLevelCategoryCode'] },
    },
  },
}
